<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.preferences.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.preferences.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-3">{{ 'chat.preferences.subtitle' | translate }}</p>

  <!-- Sound -->
  <!-- The project's standard toggle (`custom-switch` + data-switch), matching
       every other switch in the app instead of Bootstrap's `form-switch`. -->
  <div class="custom-switch mb-1">
    <input
      type="checkbox"
      id="chatPreferencesSound"
      name="chatPreferencesSound"
      data-switch="success"
      [(ngModel)]="soundEnabled"
    >
    <label for="chatPreferencesSound">
      <span>{{ 'chat.preferences.sound' | translate }}</span>
    </label>
  </div>
  <p class="text-muted mb-3"><small>{{ 'chat.preferences.soundHint' | translate }}</small></p>

  <!-- Quiet hours -->
  <div class="custom-switch mb-1">
    <input
      type="checkbox"
      id="chatPreferencesQuietHours"
      name="chatPreferencesQuietHours"
      data-switch="success"
      [(ngModel)]="quietHoursEnabled"
    >
    <label for="chatPreferencesQuietHours">
      <span>{{ 'chat.preferences.quietHours' | translate }}</span>
    </label>
  </div>
  <p class="text-muted mb-2"><small>{{ 'chat.preferences.quietHoursHint' | translate }}</small></p>

  <div class="row g-2">
    <div class="col-6">
      <label class="form-label" for="chatPreferencesQuietStart">{{ 'chat.preferences.quietHoursStart' | translate }}</label>
      <input
        id="chatPreferencesQuietStart"
        type="time"
        class="form-control"
        name="chatPreferencesQuietStart"
        [disabled]="!quietHoursEnabled"
        [(ngModel)]="quietHoursStart"
      >
    </div>
    <div class="col-6">
      <label class="form-label" for="chatPreferencesQuietEnd">{{ 'chat.preferences.quietHoursEnd' | translate }}</label>
      <input
        id="chatPreferencesQuietEnd"
        type="time"
        class="form-control"
        name="chatPreferencesQuietEnd"
        [disabled]="!quietHoursEnabled"
        [(ngModel)]="quietHoursEnd"
      >
    </div>
  </div>

  @if (companyTimezone) {
    <span class="help-block">
      <small class="text-muted">{{ 'chat.preferences.timezoneHint' | translate:{ timezone: companyTimezone } }}</small>
    </span>
  }

  @if (quietNow) {
    <div class="alert alert-info mt-2 mb-0" role="status">
      <i class="ri-moon-line me-1"></i>{{ 'chat.preferences.quietHoursActive' | translate }}
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" [disabled]="submitting" (click)="close()">
    {{ 'chat.preferences.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="submitting" (click)="save()">
    @if (submitting) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
      <span>{{ 'chat.preferences.saving' | translate }}</span>
    } @else {
      <span>{{ 'chat.preferences.save' | translate }}</span>
    }
  </button>
</div>
